import React, { PropsWithChildren } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Text.module.css";

export type TextColor =
  | "text"
  | "textSubtle"
  | "textSoft"
  | "textInverse"
  | "textDanger"
  | "textDisabled"
  | "textSuccess";

interface TextProps extends React.AllHTMLAttributes<HTMLDivElement> {
  className?: string;
  variant?:
    | "body"
    | "bodySmall"
    | "bodySmallSolid"
    | "bodyBold"
    | "heading1"
    | "default"
    | "helperError"
    | "title1"
    | "title2"
    | "title3";
  color?: TextColor;
  noWrap?: boolean;
}

const Text = React.forwardRef<HTMLDivElement, PropsWithChildren<TextProps>>(
  // eslint-disable-next-line react/prop-types
  ({ className, variant, color = "text", noWrap, children, ...props }, ref) => {
    return (
      <div
        {...props}
        ref={ref}
        className={toClassName(
          {
            [styles.textColor]: color === "text",
            [styles.textColorSubtle]: color === "textSubtle",
            [styles.textColorSoft]: color === "textSoft",
            [styles.textColorInverse]: color === "textInverse",
            [styles.textColorDanger]: color === "textDanger",
            [styles.textColorDisabled]: color === "textDisabled",
            [styles.textColorSuccess]: color === "textSuccess",
            [styles.body]: variant === "body",
            [styles.bodySmall]: variant === "bodySmall",
            [styles.bodySmallSolid]: variant === "bodySmallSolid",
            [styles.bodyBold]: variant === "bodyBold",
            [styles.title1]: variant === "title1",
            [styles.title2]: variant === "title2",
            [styles.title3]: variant === "title3",
            [styles.heading1]: variant === "heading1",
            [styles.helperError]: variant === "helperError",
            [styles.noWrap]: noWrap,
          },
          className
        )}
      >
        {children}
      </div>
    );
  }
);

Text.displayName = "Text";

export default Text;
